export default function objectOffers() {
  const root = document.querySelector("[data-offers-root]");
  const dialog = document.querySelector("[data-offer-dialog]");

  if (!root || !dialog) {
    return;
  }

  const offers = new Map();
  document.querySelectorAll("[data-offer-data]").forEach((script) => {
    try {
      const id = script.dataset.offerData;
      const data = JSON.parse(script.textContent || "{}");
      if (id) {
        offers.set(id, data);
      }
    } catch (err) {
      console.error("[offers] invalid offer payload", err);
    }
  });

  const setText = (selector, value) => {
    const el = dialog.querySelector(selector);
    if (!el) return;
    el.textContent = value || "";
    el.classList.toggle("hidden", !value);
  };

  const setVisible = (el, visible) => {
    if (!el) return;
    el.classList.toggle("hidden", !visible);
  };

  const escapeHtml = (value) => String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

  const escapeAttr = escapeHtml;

  const icons = {
    valid: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="w-18 h-18"><path d="M8 2v4"/><path d="M16 2v4"/><path d="M3 10h18"/><rect x="3" y="4" width="18" height="18" rx="2"/></svg>',
    address: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="w-18 h-18"><path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>',
    email: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="w-18 h-18"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>',
    phone: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="w-18 h-18"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.2 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.35 1.9.66 2.81a2 2 0 0 1-.45 2.11L8.05 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.31 1.85.53 2.81.66A2 2 0 0 1 22 16.92Z"/></svg>',
  };

  const renderMeta = (offer) => {
    const meta = dialog.querySelector("[data-offer-dialog-meta]");
    if (!meta) return;

    const rows = [
      offer.validUntilText ? ["valid", offer.validUntilText] : null,
      offer.contactAddress ? ["address", offer.contactAddress] : null,
      offer.contactEmail ? ["email", offer.contactEmail] : null,
      offer.contactPhone ? ["phone", offer.contactPhone] : null,
    ].filter(Boolean);

    meta.innerHTML = rows
      .map(
        ([icon, value]) => `
          <div class="flex items-center gap-8 min-w-0">
            <span class="flex-shrink-0 text-grey-600">${icons[icon] || ""}</span>
            <span class="min-w-0">${escapeHtml(value)}</span>
          </div>
        `
      )
      .join("");
    setVisible(meta, rows.length > 0);
  };

  const renderKicker = (offer) => {
    const kicker = dialog.querySelector("[data-offer-dialog-kicker]");
    if (!kicker) return;

    const parts = [offer.brand, offer.category].filter(Boolean);
    kicker.innerHTML = parts.map(escapeHtml).join(' <span aria-hidden="true">&middot;</span> ');
    setVisible(kicker, parts.length > 0);
  };

  const renderCtas = (offer) => {
    const wrap = dialog.querySelector("[data-offer-dialog-ctas]");
    if (!wrap) return;

    const ctas = Array.isArray(offer.ctas) ? offer.ctas : [];
    wrap.innerHTML = ctas
      .filter((cta) => cta && cta.url)
      .map((cta) => {
        const target = cta.target ? ` target="${escapeAttr(cta.target)}" rel="noopener"` : "";
        const title = cta.title || cta.url;
        const klass = cta.primary ? "btn-filled" : "btn-secondary";
        return `<a class="${klass}" href="${escapeAttr(cta.url)}"${target}>${escapeHtml(title)}</a>`;
      })
      .join("");

    setVisible(wrap, wrap.children.length > 0);
  };

  const openDialog = (offer) => {
    const imageWrap = dialog.querySelector("[data-offer-dialog-image-wrap]");
    const image = dialog.querySelector("[data-offer-dialog-image]");
    if (image && offer.imageUrl) {
      image.src = offer.imageUrl;
      image.alt = offer.imageAlt || offer.title || "";
    } else if (image) {
      image.removeAttribute("src");
      image.alt = "";
    }
    setVisible(imageWrap, !!offer.imageUrl);

    setText("[data-offer-dialog-category]", offer.category);
    setText("[data-offer-dialog-sale]", offer.saleLabel);
    renderKicker(offer);
    setText("[data-offer-dialog-title]", offer.title);
    setText("[data-offer-dialog-intro]", offer.intro);

    const content = dialog.querySelector("[data-offer-dialog-content]");
    if (content) {
      content.innerHTML = offer.content || "";
      setVisible(content, !!offer.content);
    }

    const couponWrap = dialog.querySelector("[data-offer-dialog-coupon-wrap]");
    setVisible(couponWrap, !!offer.couponCode);
    setText("[data-offer-dialog-coupon]", offer.couponCode);

    renderMeta(offer);
    renderCtas(offer);

    if (typeof dialog.showModal === "function") {
      dialog.showModal();
    } else {
      dialog.setAttribute("open", "");
    }
    document.body.style.overflow = "hidden";
  };

  const closeDialog = () => {
    if (typeof dialog.close === "function") {
      dialog.close();
    } else {
      dialog.removeAttribute("open");
    }
    document.body.style.overflow = "";
  };

  root.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-offer-open]");
    if (!trigger) return;

    const offer = offers.get(trigger.dataset.offerOpen);
    if (!offer) return;

    event.preventDefault();
    openDialog(offer);
  });

  dialog.addEventListener("click", (event) => {
    if (event.target === dialog || event.target.closest("[data-offer-dialog-close]")) {
      closeDialog();
    }
  });

  dialog.addEventListener("cancel", () => {
    document.body.style.overflow = "";
  });
}
